export default Object.freeze({
  unknown: 'unknownFeminine',
  s: 'S',
  m: 'M',
  l: 'L',
  xl: 'XL',
});
